export default {
  total_cash_equivalents: '',
  total_debt: ''
};
